let embedToken = '';

export const setEmbedToken = token => {
    embedToken = token;
}

export const getEmbedToken = () => {
    return embedToken;
}